import styled from 'styled-components'

export const Wrapper = styled.span<{ filled: boolean }>`
  svg {
    circle {
      fill: currentColor;
    }
  }
`
